module.exports = __webpack_public_path__ + "img/check-circle.4dee943f.svg";